module.exports = __webpack_public_path__ + "static/media/200673D.2bc7cc52.jpg";